import { render } from "./start.vue?vue&type=template&id=2768d150"
import script from "./start.vue?vue&type=script&lang=js"
export * from "./start.vue?vue&type=script&lang=js"
script.render = render

export default script